import React, { useContext } from 'react';
import { useMapEvents } from 'react-leaflet';
import { Context } from '../store/reducer';

const MapUpdate = () => {
    const { dispatch } = useContext(Context);
    useMapEvents({
        dragend: () => dispatch({type:"MAP_UPDATE"}),
        zoom: () => dispatch({type:"MAP_UPDATE"}),
    })
    return null
}

export default MapUpdate